import { Icon, typography } from '@joor/design-system'
import { useSelector } from 'react-redux'
import styled from 'styled-components/macro'

import { formatDate } from 'utils/dates'

import { getDateFormat } from 'store/currentUser/selectors'

export function WarningBanner({
  text = 'Warning',
  date,
  className = '',
}: Props) {
  const userDateformat = useSelector(getDateFormat)
  let dateStr = undefined

  if (date) {
    dateStr = userDateformat
      ? formatDate(date, `${userDateformat.toUpperCase()} HH:mm:ss`)
      : new Intl.DateTimeFormat(navigator.language ?? 'en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).format(new Date(date))
  }

  const warningText = dateStr ? `${text} on ${dateStr}` : text

  return (
    <WarningBannerContainer className={className}>
      <Icon
        data-testid={WarningBannerTestIds.WarnIcon}
        iconName="warning"
        plain
        iconSize="regular"
      />
      <Text>{warningText}</Text>
    </WarningBannerContainer>
  )
}

export type Props = {
  text?: string
  date?: string | Date
  className?: string
}

export const WarningBannerTestIds = {
  WarnIcon: 'warn-icon',
} as const

const WarningBannerContainer = styled.div`
  display: inline-flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  border: 1px solid var(--color-error-600);
  background: var(--color-error-300);
`

const Text = styled.p`
  ${typography.alpha.primaryActive.body2}
`
